const { webvisorPages, enableWebvisorAllPages } = require('./ym-config.cjs');

const { CUSTOM_PARTNER_YTM_ID, CUSTOM_YTM_ID, CUSTOM_ALFA_YTM_ID } = process.env;

const YMCountersConfig = [
    { counterId: CUSTOM_YTM_ID, webvisor: true },
    { counterId: CUSTOM_PARTNER_YTM_ID, webvisor: false },
    { counterId: CUSTOM_ALFA_YTM_ID, webvisor: false }
];

const YTM_ADDITIONAL_CODE = '';

/**
 * Счетчики Яндекс.Метрики
 */
const ytmCode = (url, counterId, webvisor) => `<script>
	(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
    for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
   m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
   (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
    
     ym(${counterId}, "init", {
        clickmap:true,
        trackLinks:true,
        accurateTrackBounce:true,
        webvisor:${enableWebvisorAllPages ? webvisor : webvisorPages.includes(url)},
        trackHash:false,
        ecommerce:"dataLayer",
   });
</script>`;

// const ytm = (url) =>
//    YMCountersConfig.map(({ counterId, webvisor }) => ytmCode(url, counterId, webvisor)).join('\n');

const ytmVarioqubCode = counterId => `
    <!-- Varioqub experiments -->
    <script type="text/javascript">
    (function(e, x, pe, r, i, me, nt){
    e[i]=e[i]||function(){(e[i].a=e[i].a||[]).push(arguments)},
    me=x.createElement(pe),me.async=1,me.src=r,nt=x.getElementsByTagName(pe)[0],nt.parentNode.insertBefore(me,nt)})
    (window, document, 'script', 'https://abt.s3.yandex.net/expjs/latest/exp.js', 'ymab');
    ymab('metrika.${counterId}', 'setConfig', { storeRedirParam: true});
    ymab('metrika.${counterId}', 'init'/*, {clientFeatures}, {callback}*/);
    </script>
`;

// const ytmVarioqub = () =>
//    YMCountersConfig.map(({ counterId }) => ytmVarioqubCode(counterId)).join('\n');

/**
 * Попарно объединяет скрипт подключения счётчика и соответствующий ему скрипт Variqub
 */
const ytmAndVarioqub = url => {
    return YMCountersConfig.map(
        ({ counterId, webvisor }) =>
            `${ytmCode(url, counterId, webvisor)}\n${ytmVarioqubCode(counterId)}`
    ).join('\n');
};

const ytmNoScriptCode = counterId =>
    `<noscript><div><img src="https://mc.yandex.ru/watch/${counterId}" style="position:absolute; left:-9999px;" alt="" /></div></noscript>`;

const ytmNoScript = () =>
    YMCountersConfig.map(({ counterId }) => ytmNoScriptCode(counterId)).join('\n');

const ytmCookie = `<script type="text/javascript">
    function setCookie(name, value, days){
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000)); 
        var expires = "; expires=" + date.toGMTString();
        document.cookie = name + "=" + value + expires + ";path=/";
    }
    function getParam(p){
        var match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
        return match && decodeURIComponent(match[1].replace(/\\+/g, ' '));
    }
    var yclid = getParam('yclid');
    if(yclid){
        setCookie('yclid', yclid, 90);
    }
</script>`;

const ytmSendUserParamsCode = counterId => `
    <script>
     (function () {
        function readCookie(name) { 
          var n = name + "="; 
          var cookie = document.cookie.split(';'); 
          for(var i=0;i < cookie.length;i++) {      
              var c = cookie[i];      
              while (c.charAt(0)==' '){c = c.substring(1,c.length);}      
              if (c.indexOf(n) == 0){return c.substring(n.length,c.length);} 
          } 
          return null; 
          }

        function send (platformId) {
          var yid = readCookie('_ym_uid');
          var time = new Date().getTime();
          var ycl_id = readCookie('yclid');

          //параметры визита и параметры пользователя
          ym(${counterId}, 'params', {
            SessionID_YM: time + "." + yid,
            platformId: platformId,
            yclid: ycl_id,
            ClientID_YM: yid
          });

          ${YTM_ADDITIONAL_CODE}
        }
        // Логика ожидания
        var pid = readCookie('platformId');
        if (pid) {
          send(pid);
        } else {
          window.addEventListener(
            'platformIdReady',
            function handler (e) {
              window.removeEventListener('platformIdReady', handler);
              send(e.detail);
            },
            { once: true }
          );
        }
      })()
    </script>
`;

const ytmSendUserParams = () =>
    YMCountersConfig.map(({ counterId }) => ytmSendUserParamsCode(counterId)).join('\n');

const ytmSendEventCode = counterId => `<script>
   var product
   var productDetail
   var pagetype
   var path
   function ytmSendEvent(dlvalues){  
      product = dlvalues.product || product || '';
      productDetail = dlvalues.product_detail || productDetail || '';
      pagetype = dlvalues.pagetype || pagetype || '';
      path = path || dlvalues.path || '';
      var action = dlvalues.action || '';
      var block = dlvalues.block || '';
      var labelDetail = dlvalues.label_detail || '';
      var event = dlvalues.event || '';   
      var dimension_40 = dlvalues.dimension_40 || '';
      var newProductDetail = productDetail && productDetail != 'undefined' ? '::'+ productDetail : ''
      var eventCategory = dlvalues.eventCategory || product+newProductDetail;
      var eventAction = dlvalues.eventAction || pagetype+'::'+block+'::'+action+'::'+dimension_40;
      var eventLabel = dlvalues.eventLabel || labelDetail+'::'+path;
      if (eventCategory && (event == 'gtm_interaction_event' || event == 'gtm_non_interaction_event')){
         ym(${counterId}, 'params', { 'event': { [eventCategory]: { [eventAction]: eventLabel }}});
      }
   }
   if (window.DATA_LAYER) { window.DATA_LAYER.subscribe(ytmSendEvent) }
</script>`;

const ytmSendEvent = () =>
    YMCountersConfig.map(({ counterId }) => ytmSendEventCode(counterId)).join('\n');

module.exports = {
    YTM_ADDITIONAL_CODE,
    ytmAndVarioqub,
    ytmNoScript,
    ytmCookie,
    ytmSendUserParams,
    ytmSendEvent
};
